import {
	Row,
	Col,
	Card,
	Image
} from 'react-bootstrap'
import Booth from './Booth'
import styles from '../styles/Event.module.scss'

interface EventBoothProps {
  props: any
}

const EventBooth: React.FC<EventBoothProps> = (eventProps: EventBoothProps) => {
	// const router = useRouter()

	const props: any = eventProps.props
	const evenRecord: any[] = []
	const oddRecord: any[] = []
	if (typeof props.event !== 'undefined') {
		for (let i = 0; i < props.event.Company.length; i++) {
			if (i % 2 === 0) {
				evenRecord.push(props.event.Company[i])
			} else {
				oddRecord.push(props.event.Company[i])
			}
		}
	}

	const institutes = [
		{ id: 2, name: 'KLC International Institute', avatar: 'https://findjobs.s3-ap-southeast-1.amazonaws.com/assets/images/institutes/klc_new.jpeg'},
		{ id: 1, name: 'National Institute of Early Childhood Development', avatar: 'https://findjobs.s3-ap-southeast-1.amazonaws.com/assets/images/institutes/niec.jpg'}
	]
	return (
		<>
			<Row className='justify-content-center'>
				<Col xs={12} md={12}>
					<Card>
						<Card.Body className={styles.bannerContainer}>
							<Image className='w-100' src={props.event.banner} alt='' />
							<br />
						</Card.Body>
					</Card>
					{/* The 3 divs below VCF banner */}
					<div style={{ width: 'calc(100% + 40px)', marginLeft: '-20px', borderBottom: '20px solid #FFAEA3', borderLeft: '20px solid transparent', borderRight: '20px solid transparent' }} />
					<div style={{ height: '45px', width: 'calc(100% + 40px)', marginLeft: '-20px', backgroundColor: '#FF9588' }} />
					<div style={{ width: 'calc(100% + 40px)', marginLeft: '-15px', height: '20px', transform: 'skew(30deg)', backgroundColor: '#EDDFDB' }} />

					<Row className='justify-content-center'>
						<Col xs={5}>
							{evenRecord.map((company: any, i: number) => {
								return <Booth key={i} company={company} boothNum={((i + 1) * 2) - 1} eventId={props.eventId} />
							})}
						</Col>
						<Col xs={2}>
							<div style={{ height: props.event.jobGroupType === 'ECDA' ? 'calc(100% + 7.8em)' : 'calc(100% + 20px)', backgroundColor: '#FF3673', borderLeft: '5px solid #EBB1C2', borderRight: '5px solid #EBB1C2' }} />
						</Col>
						<Col xs={5}>
							{oddRecord.map((company: any, i: number) => {
								return <Booth key={i} company={company} boothNum={(i + 1) * 2} eventId={props.eventId} />
							})}
						</Col>
					</Row>

					{props.event.jobGroupType === 'ECDA' && (
						<>
							<Card className='mt-5'>
								<Card.Body className={styles.bannerContainer}>
									<Image className={styles.ecdaBannerImg} src='https://findjobs.s3-ap-southeast-1.amazonaws.com/assets/images/jobFair/trainingAgencies.png' alt='' />
									<br />
								</Card.Body>
							</Card>
							<Row className='justify-content-center'>
								<Col xs={10} sm={10}>
									<Row className='justify-content-between'>
										<Col xs={1} sm={1} style={{ zIndex: 9999 }}>
											<div className={styles.trainingBoothStand} />
										</Col>
										<Col xs={1} sm={1} style={{ zIndex: 9999 }}>
											<div className={styles.trainingBoothStand} />
										</Col>
									</Row>
								</Col>
								<div className={styles.grayBlock} />
							</Row>

							<Row className='justify-content-center'>
								<Col xs={5}>
									<Booth institute={institutes[0]} />
								</Col>
								<Col xs={2}>
									<div className={styles.pinkCarpet} />
								</Col>
								<Col xs={5}>
									<Booth institute={institutes[1]} />
								</Col>
							</Row>
						</>
					)}
				</Col>
			</Row>
		</>
	)
}

export default EventBooth
